<div class="flex-row align-center mat-h2 gap-sm">
  E-Mail-Templates
</div>

<kpi4me-form-wrapper
  #form
  [GUID]="eMailGuid"
  [apiAdapter]="apiAdapter"
  (selectionChange)="selectFormControl.setValue($event)"
  (formChange)="refresh()"
  [deleteInSelectionEnabled]="false"
  [displayHeaders]="false"
  [selectionLabel]="'Template'"
></kpi4me-form-wrapper>
